export default __webpack_public_path__ + "static/media/time.8d709eca.svg";